import axios from "axios";
import { config } from "../../src/enviroment";


export const userService = {
  login,
  loginViaOTP,
  register,
  reset,
  resetForm,
  validateOTP,
  logOut,
  resendCommonOTP,
  userCheck,
  resendEmail,
  resendOTP,
  sendSignUpOTP,
  validateSignUpOTP,
  resendSignUPOTP,
  logOut,
  resendCommonOTP,
  loginViaOTP
};

async function login(username, password) {
  return new Promise((resolve, reject) => {
    axios
      .post(config.urls.LOGIN, {
        email: username,
        password: password,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function loginViaOTP(username,needotp='',customerNumber='') {
  let header ;
  if(needotp!='' && customerNumber!=''){
    header={
      email: username,
      needotp,customerNumber:customerNumber
    }
  }else{
    header = {
      email: username,
    }
  }
  return new Promise((resolve, reject) => {
    axios
      .post(
        config.urls.LOGIN_VIA_OTP,
        {
          email: username
        },
        {
          headers: header,
        }
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function register(user,tenantIdNo,FLName) {
  let APIquery={};
  if(FLName === "false"){
    APIquery={
      password: user.password,
      email: user.registeredEmail,
      phoneNumber: user.registeredCell,
      identities: [
        {
          identityValue: user.accountNumber,
          identityCode: tenantIdNo,
        },
      ],
      tenantCode: config.parameters.TENANT_CODE,
      createdBy: 0,
    };
  }else{
    APIquery={
      firstName: user.firstname,
      lastName: user.lastname,
      password: user.password,
      email: user.registeredEmail,
      phoneNumber: user.registeredCell,
      identities: [
        {
          identityValue: user.accountNumber,
          identityCode: tenantIdNo,
        },
      ],
      tenantCode: config.parameters.TENANT_CODE,
      createdBy: 0,
    };
  }
  return await axios.post(config.urls.SIGNUP, APIquery);
}

async function reset(username) {
  return await axios.post(config.urls.RESET, {
    email: username,
  });
}

async function resetForm(password, token) {
  return await axios.post(config.urls.RESETFORM, {
    password: password,
    token: token,
  });
}

async function validateOTP({ userName, otp, password,customerNumber='' }) {
  const validateOTPObject = {};
  const flowType = localStorage.getItem("flowType");
  if (flowType === "LOGIN_OTPVERIFIED" || flowType === "LOGIN") {
    validateOTPObject.password = password;
    validateOTPObject.otp = Number(otp);
    validateOTPObject.flowType = flowType;
  } else {
    validateOTPObject.otp = Number(otp);
    validateOTPObject.flowType = flowType;
  }
  let header;
  let cNo=localStorage.getItem("updating")
  if(customerNumber!=''){
      header={
        customerNumber:flowType=="FORGOT_PASSWORD"?cNo:customerNumber,
        username:userName
      }
  }else{
    header={
      username:userName,
      customerNumber:flowType=="FORGOT_PASSWORD"?cNo:null,
    }
  }
  return await axios.post(config.urls.VALIDATEOTP, validateOTPObject, {
    headers: header,
  });
}

async function resendOTP(email) {
  return await axios.post(config.urls.LOGIN_RESENDOTP, {
    userName: email,
    flowType: 'LOGIN',
    tenantCode: config.parameters.TENANT_CODE,
  });
}

async function sendSignUpOTP(email) {
  return await axios.post(config.urls.SIGNUP_SENDOTP, {
    email: email,
    tenantCode: config.parameters.TENANT_CODE,
  });
}

async function validateSignUpOTP(otp, otpid, email) {
  return await axios.post(config.urls.SIGNUP_VALIDATEOTP, {
    otpValue: otp,
    otpId: otpid,
    email: email,
    tenantCode: config.parameters.TENANT_CODE,
  });
}

async function resendSignUPOTP(email, otpid) {
  return await axios.post(config.urls.SIGNUP_RESENDOTP, {
    userName: email,
    tenantCode: config.parameters.TENANT_CODE,
    flowType: 'SIGNUP',
  });
}

async function resendCommonOTP(email) {
  const flowType = localStorage.getItem("flowType");
  return await axios.post(
    config.urls.SIGNUP_RESENDOTP,
    {
      flowType,
    },
    {
      headers: {
        userName: email,
      },
    }
  );
}

async function logOut(sessionId, email) {
  return await axios.post(config.urls.LOGOUT, {
    sessionId: sessionId,
    email: email,
  });
}

async function userCheck(username) {
  return new Promise((resolve, reject) => {
    axios
      .get(config.urls.USERCHECK,{
        headers:{
          "username":username
        }
      })
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

async function resendEmail(userName) {
  return new Promise((resolve, reject) => {
    axios
      .post(config.urls.RESEND_EMAIL, 
        {
        query: 
        `query{resendEmail (username:"`+userName+`"){ isOk } }`,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
